import styled from 'styled-components';
import { Fonts, Palette } from '../../../../../components/utils';

export const UpdateAmenityStickyHeader = styled.div`
  position: sticky;
  top: 0;
  z-index: 2;
  flex-shrink: 0;
  background: ${Palette.WHITE};
  padding: 24px 24px 16px;
  box-sizing: border-box;
`;

export const UpdateAmenityHeaderRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
`;

export const UpdateAmenityHeaderTitle = styled.h2`
  flex: 1 1 auto;
  min-width: 0;
  margin: 0;
  color: ${Palette.BLACK};
  font-family: ${Fonts.RED_HAT_FONT}, 'Red Hat Display', sans-serif;
  font-size: 24px;
  font-weight: 700;
  line-height: 32px;
`;

export const UpdateAmenityHeaderActions = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
`;

export const UpdateAmenityCloseButton = styled.button`
  width: 24px;
  height: 24px;
  padding: 0;
  border: 1px solid ${Palette.STROKE_GREY};
  border-radius: 50%;
  background: ${Palette.WHITE};
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  flex-shrink: 0;

  &:focus-visible {
    outline: 2px solid ${Palette.OCEANIC};
    outline-offset: 2px;
  }
`;

export const UpdateAmenityCoverBanner = styled.img`
  align-self: stretch;
  width: 100%;
  height: 176px;
  object-fit: cover;
  display: block;
  flex-shrink: 0;
`;

export const UpdateAmenityAccordionStack = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 16px;
  padding: 16px 24px 24px;
  box-sizing: border-box;
`;

export const UpdateAmenityFooterValidationHint = styled.p`
  margin: 0;
  color: ${Palette.ERROR};
  font-family: ${Fonts.OPEN_SANS_FONT}, sans-serif;
  font-size: 12px;
  font-weight: 600;
  line-height: 24px;
  text-align: center;
`;
